import {Badge} from "antd";
import FontAwesomeIcon from "~/components/FontAwesome";
import {Link} from "react-router-dom";
import {useCan} from "~/hooks";
import {useGetPlanRequestsQuery, useGetExtraPurchasesQuery} from "~/reduxs/api/memberApiSlice";

/** Nhãn menu kèm badge số lượng đang chờ duyệt (ẩn khi = 0). */
const labelWithBadge = (to, text, count) => (
	<Link to={to}>
		{text}
		{count > 0 && <Badge count={count} size="small" offset={[6, -2]} />}
	</Link>
);

/**
 * Menu điều hướng CHẾ ĐỘ QUẢN TRỊ (/admin/*).
 *
 * Gọi trong render của AdminSidebar nên dùng hook useCan ở đây hợp lệ.
 */
export const AdminNavData = () => {

	const canMember = useCan('member_manage');
	const canPermission = useCan('permission');

	// Số đơn chờ duyệt để hiện badge trên menu (chỉ tải khi có quyền quản trị thành viên).
	const {data: planReqs} = useGetPlanRequestsQuery('pending', {skip: !canMember});
	const {data: extraReqs} = useGetExtraPurchasesQuery('pending', {skip: !canMember});
	const planPending = planReqs?.pending_count || 0;
	const extraPending = extraReqs?.pending_count || 0;

	const items = [];

	if (canMember) {
		items.push(
			{
				key: 'admin-stats',
				label: <Link to="/admin/stats">Thống kê tổng quan</Link>,
				title: 'Thống kê tổng quan',
				to: '/admin/stats',
				icon: <FontAwesomeIcon icon="fa-light fa-chart-pie" />,
			},
			{
				key: 'admin-members',
				label: <Link to="/admin/members">Thành viên</Link>,
				title: 'Thành viên',
				to: '/admin/members',
				icon: <FontAwesomeIcon icon="fa-light fa-users" />,
			},
			{
				key: 'admin-plan-requests',
				label: labelWithBadge('/admin/plan-requests', 'Yêu cầu nâng cấp', planPending),
				title: 'Yêu cầu nâng cấp',
				to: '/admin/plan-requests',
				icon: <FontAwesomeIcon icon="fa-light fa-crown" />,
			},
			{
				key: 'admin-extra-purchases',
				label: labelWithBadge('/admin/extra-purchases', 'Mua gói Extra', extraPending),
				title: 'Mua gói Extra',
				to: '/admin/extra-purchases',
				icon: <FontAwesomeIcon icon="fa-light fa-cart-plus" />,
			},
			{
				key: 'admin-plans',
				label: <Link to="/admin/plans">Gói dịch vụ</Link>,
				title: 'Gói dịch vụ',
				to: '/admin/plans',
				icon: <FontAwesomeIcon icon="fa-light fa-box-open" />,
			},
			{
				key: 'admin-google-ads',
				label: <Link to="/admin/google-ads">Google Ads</Link>,
				title: 'Google Ads',
				to: '/admin/google-ads',
				icon: <FontAwesomeIcon icon="fa-light fa-rectangle-ad" />,
			},
			{
				key: 'admin-services',
				label: <Link to="/admin/services">Dịch vụ bên thứ 3</Link>,
				title: 'Dịch vụ bên thứ 3',
				to: '/admin/services',
				icon: <FontAwesomeIcon icon="fa-light fa-plug" />,
			},
		);
	}

	if (canPermission) {
		items.push({
			key: 'admin-permission',
			label: <Link to="/admin/permission">Phân quyền</Link>,
			title: 'Phân quyền',
			to: '/admin/permission',
			icon: <FontAwesomeIcon icon="fa-light fa-user-lock" />,
		});
	}

	return items;
}
